import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  button: {
    outline: '1px solid #159B78 !important',
    color: '#159B78'
  },
  icon: {
    marginRight: '8px'
  }
}));
